export default __webpack_public_path__ + "static/media/PROCESSMETHOD_PRINTING_SLM_DMLS.e34e87e3.png";